import { createFileRoute } from '@tanstack/react-router';
import { Button, buttonVariants, Spinner, Text, VStack } from 'ui_2';
import { ArcadeStoreRewardRows } from '@src/components/store/ArcadeStoreRewardRows';
import Header from '@src/components/layout/Header';
import { Route as index_route } from '@routes/index';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import {
  useBreakpoints,
  useHasInjectedConnection,
} from '@puzzlehq/frontend-utils';
import { BiLinkExternal } from 'react-icons/bi';
import { Page } from '@src/components/layout/Page';
import { usePendingOrders } from '@src/hooks/useArcadeStore';
import { PendingOrderRow } from '@src/components/pendingPurchase/PendingOrderRow';

export const Route = createFileRoute('/rewards')({
  staticData: {
    title: 'Rewards',
  },
  head: () => ({
    meta: [
      {
        name: 'description',
        content: `View your store items.`,
      },
      {
        title: `Store Items`,
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { connect, isConnected, connectLoading } = useArcadeStoreState();
  const { hasInjectedConnection, isLoading } = useHasInjectedConnection();

  const renderDownloadPuzzle = () => (
    <VStack className='h-full items-center justify-center text-center'>
      <Text>Download Puzzle Wallet to view your store items.</Text>
      <a
        href='https://puzzle.online/wallet'
        target='_blank'
        className={buttonVariants({
          className: 'w-full max-w-[300px] items-center gap-2',
        })}
      >
        Download Puzzle Wallet
        <BiLinkExternal />
      </a>
    </VStack>
  );

  const renderConnect = () => (
    <VStack className='h-full items-center justify-center gap-1 text-center'>
      <Text>Connect your Puzzle Wallet to view your purchases.</Text>
      <Button
        onClick={() => connect?.()}
        disabled={connect === undefined || connectLoading}
        className='w-full max-w-[300px] items-center gap-2'
      >
        Connect
        {connectLoading && <Spinner />}
      </Button>
    </VStack>
  );

  const renderButton = () => {
    if (hasInjectedConnection === false && isLoading === false) {
      return renderDownloadPuzzle();
    } else {
      return renderConnect();
    }
  };

  const { isMedium } = useBreakpoints();
  const { data: pendingOrders, isSuccess } = usePendingOrders();

  return (
    <Page title='Store Items' backRoute={index_route.to}>
      <VStack className={`h-auto w-full gap-4`}>
        {isSuccess && pendingOrders.length > 0 && (
          <>
            <Text font={isMedium ? 'bold-lg' : 'bold-md'}>Ongoing Orders</Text>
            <VStack className={`gap-4 pb-8`}>
              {pendingOrders.map((order, ix) => (
                <PendingOrderRow order={order} key={ix} />
              ))}
            </VStack>
          </>
        )}
        {isConnected ? <ArcadeStoreRewardRows /> : renderButton()}
      </VStack>
    </Page>
  );
}
